import ScraperConfigStore from '../store/scraper-config-store';
import {ScraperConfigResource} from '../../entity/resource/scraper-config-resource';

export default class ScraperConfigService {
  scraperConfigStore: ScraperConfigStore;

  constructor(scraperConfigStore: ScraperConfigStore) {
    this.scraperConfigStore = scraperConfigStore;
  }

  getScraperConfig = async (countyId: string): Promise<ScraperConfigResource | undefined> => {
    return this.scraperConfigStore.getScraperConfig(countyId);
  }
}
